import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import moment from "moment";
import io from "socket.io-client";

import QuantitySelector from "../../components/QuantitySelector";
import ModalInterval from "../../components/ClientSite/ModalInterval";
import ClientButton from "../../components/ClientButton";
import { getReservationSchedulesClientPortal, createReservationClientPortal } from '../../store/actions/reservation';
import { getStateValue } from "../../store/selectors";
import translations from "../../utils/translations";
import Colors from "../../constants/colors"
import saveIcon from "../../images/icons8-guardar-96.png";
import calendarIcon from "../../images/icons8-calendar-100.png";
import clockIcon from "../../images/icons8-clock-128.png";
import teamIcon from "../../images/icons8-team-96-blue.png";
import commentIcon from "../../images/icons8-comment-96.png";

let socket

const ReservationFormPage = (props) => {
  const {
    getReservationSchedulesClientPortal,
    createReservationClientPortal,
    saveReservation,
    
    currentTranslations,
    party_limit,
    save,
    client,
    foodStallId,
    sysCompanyId,
  } = props;

  const dateRef = useRef(null)
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [schedulesAvailables, setSchedulesAvailables] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null)
  const [isIntervalModalVisible, setIsIntervalModalVisible] = useState(null)
  const [selectedIntervals, setSelectedIntervals] = useState([]);
  const [quantity, setQuantity] = useState(2)
  const [comment, setComment] = useState('')

  useEffect(() => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}`;
    socket = io(url, {
      path: "/host-socket",
      transports: ["websocket"],
      query: {
        client_id: client?.id,
        sys_company_id: foodStallId ? foodStallId : sysCompanyId,
      },
    });

    socket.on("connect", () => {
      console.log("client Connected");
    });

    socket.on("disconnect", () => {
      console.log("client Disconnected");
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const schedules = await getReservationSchedulesClientPortal(null, selectedDate)
        setSchedulesAvailables(schedules)
      } catch(error){
        console.log('error fetching schedules', error)
      }
    }

    fetchSchedules()
  }, [selectedDate])
  
  useEffect(async () => {
    if(save){
      const reservationData = {
        additional_comments: comment,
        client_id: client?.id,
        party: quantity,
        reserv_date: moment(selectedDate).format(),
        selectedIntervals,
        sys_company_id: foodStallId ? foodStallId : sysCompanyId
      }
      const newReservation = await createReservationClientPortal(reservationData)
      socket.emit('sendNewReservation', newReservation)
      saveReservation(false)
      props.history.goBack()
    }
  }, [save])

  const openPicker = () => {
    dateRef.current?.showPicker()
  }

  const openTimePicker = () => {
    setIsIntervalModalVisible(true)
  }


  return (
    <div style={styles?.page}>
      {/* Date picker */}
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img src={calendarIcon} style={{width: '25px', height: '25px'}}/>

        <input
          ref={dateRef}
          type="date"
          style={{ display: "none" }}
          onChange={(e) => {
            const value = e.target.value
            setSelectedDate(moment(value).format())
          }}
        />

        <button onClick={openPicker} style={{flex: 1, margin: '0px 3vh', border: `1px solid ${Colors?.primary}`, backgroundColor: 'white', borderRadius: '8px', fontWeight: '500', fontSize: '16px', padding: '1vh 0px', color: Colors?.primary}}>
          {moment(selectedDate).format('DD/MM/YYYY')}
        </button>
      </div>

      {/* Time picker */}
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '1vh 0px'}}>
        <img src={clockIcon} style={{width: '25px', height: '25px'}}/>

        <button onClick={openTimePicker} style={{flex: 1, margin: '0px 3vh', border: `1px solid ${Colors?.primary}`, backgroundColor: 'white', borderRadius: '8px', fontWeight: '500', fontSize: '16px', padding: '1vh 0px', color: Colors?.primary}}>
          {selectedTime ? moment(selectedTime, 'HH:mm').format('HH:mm') : currentTranslations?.reservationTime}
        </button>
      </div>
      
      {/* Number of people */}
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '1vh 0px'}}>
        <img src={teamIcon} style={{width: '25px', height: '25px'}}/>

        <div
          style={{
            flex: 1, 
            margin: '0px 3vh',
          }}
        >
          <div style={{flex: 1, fontWeight: '500', fontSize: '16px', padding: '0px 0px 1vh 0px', color: Colors?.primary}}>
            {currentTranslations?.numberOfPeople}
          </div>
          
          <QuantitySelector
            quantity={quantity}
            onChangeQuantity={(newQuantity) => {
              if(party_limit && (party_limit < newQuantity)) {
                alert(`${currentTranslations?.partyLimitIs} ${party_limit}`)
                return
              };
              setQuantity(newQuantity)
            }}
            isFromModal={false}
            mainContainerStyle={{ justifyContent: 'flex-start' }}
          />
        </div>
      </div>

      {/* Comment */}
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '1vh 0px'}}>
        <img src={commentIcon} style={{width: '25px', height: '25px'}}/>

        <textarea
          type="text"
          onChange={(e) => {
            const value = e.target.value
            setComment(value)
          }}
          value={comment}
          placeholder="Comentarios adicionales"
          maxLength={200}
          style={{
            flex: 1, 
            margin: '0px 3vh', 
            padding: '10px 15px', 
            border: `0px solid ${Colors?.primary}`, 
            backgroundColor: Colors?.gray, 
            borderRadius: '8px', 
            fontWeight: '500', 
            fontSize: '16px',  
            marginTop: 8,
            color: "black",
            height: 100,
            resize: "none",
            width: '100%'
          }}
        />
      </div>

      {/* Selected times label, List of selected intervals */}
      <div style={{flex: 1, fontWeight: '500', fontSize: '14px', padding: '0px 0px 1vh 0px', color: Colors?.primary}}>
        {/* Selected times label */}
        {currentTranslations?.selectedTimes}:
        
        <br/>

        {/* List of selected intervals */}
        {selectedIntervals?.map(item => (
          <div>
            {moment(item.start, 'HH:mm').format('HH:mm')} - {moment(item.end, 'HH:mm').format('HH:mm')}
          </div>
        ))}
      </div>

      {/* Interval Modal */}
      <ModalInterval
        visible={isIntervalModalVisible}
        intervals={schedulesAvailables}
        columns={3}
        onClose={() => setIsIntervalModalVisible(false)}
        setSelectedIntervals={setSelectedIntervals}
        selectedIntervals={selectedIntervals}
        onAccept={() => {
          setIsIntervalModalVisible(false);
        }}
      />
    </div>
  );
};

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    overflowY: 'scroll',
    position: 'relative',
    'scrollbar-width': 'none',
    padding: '4vh'
  },
}

const mapDispatchToProps = (dispatch) => ({
  getReservationSchedulesClientPortal: (sysCompanyId, reservationDateTime) => {
    return dispatch(getReservationSchedulesClientPortal(sysCompanyId, reservationDateTime))
  }, 
  createReservationClientPortal: (data) => {
    return dispatch(createReservationClientPortal(data))
  },
  saveReservation: (save) => dispatch({type: 'SAVE_RESERVATION', payload: save}),
});

const mapStateToProps = (state) => ({
  currentTranslations: translations[state.app.lang],
  party_limit: state.access?.company?.ExtraData?.party_limit,
  save: state?.reservations?.save,
  client: state?.app?.client,
  foodStallId: state.access?.foodStallId,
  sysCompanyId: state.access?.sysCompanyId
});

export const ReservationFormHeader = connect(mapStateToProps, mapDispatchToProps)((props) =>{
  const {
    saveReservation,

    currentTranslations,
  } = props

  return (
    <ClientButton 
      style={{display: 'flex', flexDirection: 'row', alignItems: 'center', fontSize: '12px', width: 'auto'}}
      onClick={() => saveReservation(true)}
    >
      <img src={saveIcon} style={{width: '20px', height: '20px'}}/>
      <div>
        {currentTranslations?.save}
      </div>
    </ClientButton>
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(ReservationFormPage);